module.exports = __webpack_public_path__ + "res/27-img_game_bg_t_r.4d2e21877f7fc19a1e62a58ecea0deba.png";